<template>
	<div>
		<div class="show_box">
			<div v-if="!nullFlag" class="text_box">
				<div v-for="(item, index) in list" :key="index" >
					{{ item.deviceType | typeFilter }}：<span class="text" v-if="item.equipmentBid"
						>{{ item.lifting | liftingFilter }}{{ item.equipmentBid }}%</span
					><span class="text" v-else>-</span>
				</div>
			</div>
			<div v-else>-</div>
			<ig-icon name="bianji" class="bianji-icon" @click="change"></ig-icon>
		</div>
		<el-dialog
			:visible.sync="dialogVisible"
			:close-on-click-modal="false"
			width="500px"
			:before-close="resetFields"
		>
			<div slot="title">
				<span class="motitle">广告系列设备出价调整</span
				><span class="subTitle">提示：要移除出价，将数据留空保存</span>
			</div>
			<el-form ref="form" :model="form" :rules="rules" label-width="80px" class="formdialog">
				<el-form-item
					:label="item.deviceType | typeFilter"
					:prop="'equipmentBid' + index"
					v-for="(item, index) in list"
					:key="index"
				>
					<div class="content">
						<el-input
							:placeholder="placeholder | placeholderFilter(item.lifting)"
							v-model.number="form['equipmentBid' + index]"
							style="width: 90%"
							oninput="value=value.replace(/[^0-9.]/g,'')"
							:disabled="typeVal == 1 && item.lifting == 1 && item.equipmentBid == 100"
						>
							<el-select
								:disabled="typeVal == 1 && item.lifting == 1 && item.equipmentBid == 100"
								v-model="item.lifting"
								slot="prepend"
								placeholder="请选择"
								class="input-with-select"
								@change="opChange(item, index)"
							>
								<el-option
									v-for="item in options"
									:key="item.value"
									:label="item.label"
									:value="item.value"
								></el-option>
							</el-select>
						</el-input>
						<div class="append">%</div>
					</div>
				</el-form-item>
			</el-form>
			<div class="btn-box">
				<el-button @click="resetFields">取消</el-button>
				<el-button type="primary" @click="onSubmit">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import adsNewOnlineSer from '@/backend/services/adsNewOnline/adsNewOnlineSer.js';
export default {
	props: {
		tableData: Object,
		scope: Object,
		typeVal: null,
	},
	data() {
		let that = this;
		var validateInputVal = (rule, value, callback) => {
			let ruleVal = that.list[rule.index].lifting ? 90 : 900;
			let errorMsg = that.list[rule.index].lifting
				? '请输入100，或1~90的整数'
				: '请输入1~900的整数';
			if (!value) {
				if (value === 0) {
					callback(new Error(errorMsg));
				} else {
					callback();
				}
			} else {
				let baseflag = Number(value) <= 0 || Number(value) > ruleVal;
				let twoflag =
					Number(value) <= 0 || (90 < Number(value) && Number(value) < 100) || Number(value) > 100;
				let flag = ruleVal == 90 ? twoflag : baseflag;
				if (flag) {
					callback(new Error(errorMsg));
				} else {
					callback();
				}
			}
		};
		return {
			form: {
				equipmentBid0: '',
				equipmentBid1: '',
				equipmentBid2: '',
			},
			rules: {
				equipmentBid0: [{ validator: validateInputVal, trigger: 'blur', index: 0 }],
				equipmentBid1: [{ validator: validateInputVal, trigger: 'blur', index: 1 }],
				equipmentBid2: [{ validator: validateInputVal, trigger: 'blur', index: 2 }],
			},
			optionVal: 0,
			dialogVisible: false,
			options: [
				{ label: '提高', value: 0 },
				{ label: '降低', value: 1 },
			],
			placeholder: '',
		};
	},

	components: {},

	computed: {
		list() {
			if (this.scope.row[this.tableData.bind]) {
				this.scope.row[this.tableData.bind].forEach(e => {
					if (typeof e.equipmentBid == 'string') {
						let str = e.equipmentBid.replaceAll('-', '').replaceAll('%', '');
						e.equipmentBid = Number(str);
					}
				});
			}
			let val = this.scope.row[this.tableData.bind] ? this.scope.row[this.tableData.bind] : '';
			let val1=val.filter((e)=>{return e.deviceType==0});
			let val2=val.filter((e)=>{return e.deviceType==1});
			let val3=val.filter((e)=>{return e.deviceType==2});
		
			let arr = [
				{
					deviceType: 0,
					equipmentBid:val1 ? val1[0]?.equipmentBid : '',
					lifting: val1[0]?.equipmentBid ? val1[0]?.lifting : 1,
				},
				{
					deviceType: 1,
					equipmentBid: val2 ? val2[0]?.equipmentBid : '',
					lifting: val2[0]?.equipmentBid ? val2[0]?.lifting : 1,
				},
				{
					deviceType: 2,
					equipmentBid: val3 ? val3[0]?.equipmentBid : '',
					lifting: val3[0]?.equipmentBid ? val3[0]?.lifting : 1,
				},
			];

			return arr;
		},
		nullFlag()
		{
			let bolValue =this.list.every(item => item.equipmentBid=='');
			return bolValue;
		}
	},
	watch: {
		list: {
			handler(val) {
				if (val && val.length) {
					this.form = {
						equipmentBid0: val[0]?.equipmentBid || '',
						equipmentBid1: val[1]?.equipmentBid || '',
						equipmentBid2: val[2]?.equipmentBid || '',
					};
				}
			},
			immediate: true,
		},
	},

	filters: {
		typeFilter(val) {
			switch (val) {
				case 0:
					return '平板电脑';
				case 1:
					return '计算机';
				case 2:
					return '手机';
			}
		},
		placeholderFilter(val, val1) {
			return val1 ? '请输入100，或1~90的整数' : '请输入1~900的整数';
		},
		liftingFilter(val) {
			return val ? '-' : '+';
		},
	},
	methods: {
		change() {
			this.dialogVisible = true;
		},
		opChange(item, index) {
			let ruleVal = item.lifting ? 90 : 900;
			let errorMsg = item.lifting ? '请输入100，或1~90的整数' : '请输入1~900的整数';
			var validateInputVal = (rule, value, callback) => {
				if (!value) {
					if (value === 0) {
						callback(new Error(errorMsg));
					} else {
						callback();
					}
				} else {
					let baseflag = Number(value) <= 0 || Number(value) > ruleVal;
					let twoflag =
						Number(value) <= 0 ||
						(90 < Number(value) && Number(value) < 100) ||
						Number(value) > 100;
					let flag = ruleVal == 90 ? twoflag : baseflag;
					if (flag) {
						callback(new Error(errorMsg));
					} else {
						callback();
					}
				}
			};
			this.rules['equipmentBid' + index] = [{ validator: validateInputVal, trigger: 'blur' }];
			this.$forceUpdate();
		},
		onSubmit() {
			this.$refs['form'].validate(valid => {
				if (valid) {
					this.updata();
				} else {
					return false;
				}
			});
		},
		resetFields() {
			this.$refs['form'].resetFields();
			this.dialogVisible = false;
		},
		async updata() {
			this.list.forEach((e, i) => {
				return (e.equipmentBid = this.form['equipmentBid' + i]);
			});
			let arr = this.list.filter(item => item.equipmentBid);
			let res = await adsNewOnlineSer.update_ads(
				{
					id: this.scope.row.id,
					deviceCriteriaInfoDTOList: arr,
					state: this.tableData.state, //0,核心推广产品;1,国家/地区
					isEmptyDeviceBid: arr.length ? 0 : 1,
				},
				{ type: this.typeVal } ///0,广告系列;1,广告组
			);
			if (res.data) {
				this.$refs['form'].resetFields();
				this.dialogVisible = false;
				this.$message({
					message: '修改成功',
					type: 'success',
				});
				let { scope, tableData } = this;
				tableData.change();
			} else {
				this.$message.error({
					message: '修改失败',
				});
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.show_box {
	display: flex;
	align-items: center;
	.text_box {
		flex: 1;
		.text {
			display: inline-block;
			margin-left: 5px;
		}
	}
}
.subTitle {
	font-size: 13px;
	font-weight: 400;
	color: #999999;
	margin-left: 10px;
}
.motitle {
	font-size: 16px;
}
.bianji-icon {
	margin-left: 10px;
	cursor: pointer;
}
.input-with-select {
	width: 100px;
}
.content {
	display: flex;
}
.append {
	line-height: 40px;
	text-align: center;
	padding-left: 5px;
}
.formdialog ::v-deep  .el-form-item__error {
	left: 100px !important;
}
.btn-box {
	text-align: right;
}
</style>
